import React from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 15px;
  width: 17.5px;
  margin: auto;

  @media (min-width: 1800px) {
    height: 23.4px;
    width: 27.11px;
  }

  @media (max-width: 575px) {
    height: 17.499px;
    width: 15px;
  }
`;

function CommentOutlined() {
  return (
    <Container>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="100%"
        width="100%"
        viewBox="0 0 17.499 15"
      >
        <path
          fill="none"
          d="M8.749.614C4.267.614.614 3.484.614 7.025a6.022 6.022 0 003.09 5.031.456.456 0 01.195.508 4.319 4.319 0 01-1.115 1.82 4.7 4.7 0 003.292-1.074.435.435 0 01.411-.116 10.074 10.074 0 002.259.254c4.483 0 8.135-2.875 8.135-6.411S13.232.614 8.749.614z"
        />
        <path
          fill="#fff"
          d="M8.749 0C3.927 0 0 3.157 0 7.042a6.546 6.546 0 003.108 5.39 2.222 2.222 0 01-1.932 1.54.432.432 0 00-.091.854A9.508 9.508 0 002.919 15a5.608 5.608 0 003.675-1.127 10.986 10.986 0 002.156.217c4.823 0 8.749-3.157 8.749-7.042S13.572 0 8.749 0zm0 13.222a9.868 9.868 0 01-2.191-.245.419.419 0 00-.4.112 4.574 4.574 0 01-3.192 1.036 4.159 4.159 0 001.078-1.757.435.435 0 00-.182-.49 5.792 5.792 0 01-3-4.851C.868 3.619 4.41.847 8.756.847s7.888 2.772 7.888 6.181-3.544 6.194-7.895 6.194z"
        />
      </svg>
    </Container>
  );
}

export default CommentOutlined;
